import { useConfig } from '@crystal/config'
import { useDevice } from '@crystal/core'
import { Translations, useTranslations } from '@crystal/translator'
import { FC } from 'react'

import { AccountPortalConfig } from '../config'

import styles from './social-login.module.scss'
import { SocialLoginButton } from './SocialLoginButton'

interface SocialLoginProps {
  persistentLogin?: boolean
  fullWidthButtons?: boolean
  emphasizeSocialLogin?: boolean
  isEmailButton?: boolean
  analytics?: {
    originLocation?: string
  }
}

export const SocialLogin: FC<SocialLoginProps> = ({
  persistentLogin,
  fullWidthButtons,
  emphasizeSocialLogin,
  isEmailButton,
  analytics,
}) => {
  const t = useTranslations<Translations>()
  const { socialLoginProviders } = useConfig<AccountPortalConfig>()

  const { isMobile } = useDevice()
  const compactButtons = (isMobile || socialLoginProviders.length > 1) && !emphasizeSocialLogin

  return (
    <div
      className={`gl-vspace-bpall-small
       ${compactButtons ? `gl-flex-display ${styles.flexGap}` : ''}
       ${emphasizeSocialLogin ? `${styles.fullWidth}` : ''}
       ${isEmailButton ? `${styles.email_button}` : ''}
       `}>
      {socialLoginProviders.map(provider => (
        <SocialLoginButton
          key={provider.id}
          providerId={provider.id}
          displayName={emphasizeSocialLogin ? t('login.continue_with', provider.displayName) : provider.displayName}
          persistentLogin={persistentLogin}
          compactButtons={compactButtons}
          fullWidthButtons={fullWidthButtons}
          analytics={analytics}
        />
      ))}
    </div>
  )
}
